<script setup lang="ts">
import { computed, ref } from 'vue'
import ResourceImage from '../resourceImage.vue'

defineProps<{
  resource: {
    _id: string
    picture: string
    firstname: string
    lastname: string
  }
}>()
</script>

<template>
  <ResourceImage :resource="resource" size="w-6 h-6" disable-link />
  <p class="line-clamp-1" :data-cy = "`combobox-item-${resource.firstname} ${resource.lastname}`" >
    {{ resource.firstname }} {{ resource.lastname }}
  </p>
</template>
